import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';

@Component({
  selector: 'app-accounts-info-widget',
  templateUrl: './accounts-info-widget.component.html',
  styleUrls: ['./accounts-info-widget.component.scss'],
  standalone: false
})

export class AccountsInfoWidgetComponent implements OnInit, OnDestroy {
  @Input() customerInfo?: any;
  @Input() leadInfo?: any;

  customerId: string;
  leadId: string;
  appStrings: AppLocalization;
  accountDetails;
  notesList: any[];
  loading = true;

  dialogOpen$ = new EventEmitter<boolean>();
  dialogButtons=[{ label: 'Close', type: 'primary'}];
  dialogText: any;

  constructor(
    private appInfoService: AppInfoService,
    private activatedRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.customerId = this.activatedRoute.snapshot.params['customerId'];
    this.leadId = this.activatedRoute.snapshot.params['leadId'];
    this.appStrings = this.appInfoService.appStrings;
    this.accountDetails = null;
    this.accountDetails = {};
    this.notesList = [];

    if (this.leadInfo) {
      this.setValues(this.leadInfo);
    }
    if (this.customerInfo) {
      this.setValues(this.customerInfo);
    }
  }

  private setValues(values: any) {
    values.priceMatrix = values.priceMatrix ? values.priceMatrix : '';
    values.paymentTerms = values.paymentTerms ? values.paymentTerms : '';
    values.creditLimit = values.creditLimit ? values.creditLimit : '';
    values.billToAddress = values.billToAddress ? values.billToAddress : '';
    values.shipToAddress = values.shipToAddress ? values.shipToAddress : '';
    values.hasAvailableCredit = values.creditLimit && values.creditLimit > 0 ? this.appStrings.yes : this.appStrings.no;
    this.notesList = values.lnNotes ? values.lnNotes : [];
    this.accountDetails = values;
  }

  ngOnDestroy(): void {
    // This is intentional
  }

  onNotesClick(event: Event): void {
    event.preventDefault();
    const notes = this.notesList?.filter(note => note.note).map(note => note.note);
    this.dialogText = notes?.length ? notes : this.appStrings.noEntriesFound;
    this.cdRef.detectChanges();
    this.dialogOpen$.emit(true);
  }
}
